import { createSlice } from "@reduxjs/toolkit";

export const clientesSlice = createSlice({
    name: 'clientes',
    initialState: {
        allClientes: [],
        clienteId:[],
        clienteNew: {}
    },
    reducers: {
      allClientes: (state, {payload}) => {
        state.allClientes = payload
      },
      clienteId: (state, {payload}) => {
        state.clienteId = payload
      },
      clienteNew: (state, {payload}) => {
        state.clienteNew = payload
      }  
    }
})

export const { allClientes, clienteId, clienteNew } = clientesSlice.actions;

export default clientesSlice.reducer;